import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class TransferTransactionsCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(transaction_ids:Array<String>, bank_account_id:Number|String): Promise<any> {
    let args = { 
      transaction_ids: transaction_ids,
      bank_account_id: bank_account_id,
    }
    this.frontend.transferTransactionsPopup = false;
    try {
      let res = await this.dispatcher.dispatch('transfer.transaction', args)
      this.frontend.action = 'transfer_transactions'
      this.frontend.asyncJobState = 'running'
      this.frontend.asyncJobId = res.job_id
    } catch (error) {
      console.error('Error while transferring transactions', error)
      this.frontend.asyncJobState = 'done'
      this.frontend.genericInformationDialogMsg = "Error al realizar las transferencias entre cuentas."
      this.frontend.transferTransactionsPopup = true
    }
  }
}